import { render } from "./Navbar.vue?vue&type=template&id=58fdb388"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
script.render = render

export default script